import React from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const location = useLocation();
    const hideFooterPaths = ['/dashboard'];
    const shouldHideFooter = hideFooterPaths.includes(location.pathname);

    return (
        <div className="min-h-screen bg-black flex flex-col overflow-x-hidden">
            <Header />

            {/* Main Content — 설치형 웹앱(standalone)은 상태바 밑까지 화면을 쓰므로
                고정 헤더 높이에 safe-area 상단 인셋을 더해 본문이 헤더에 물리지 않게 한다.
                이 틀 안의 페이지는 상단 인셋을 또 넣지 않는다 — 두 번 넣으면 아이폰 홈 화면 앱에서
                헤더 밑에 빈 띠가 생긴다(2026-10-14 크레딧 충전 화면 대표 제보) */}
            <motion.main
                className="flex-1 pt-[calc(4rem+env(safe-area-inset-top))] overflow-x-hidden"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
            >
                {children}
            </motion.main>

            {!shouldHideFooter && <Footer />}
        </div>
    );
};

export default Layout; 